import React from 'react';
import { GlobalStyles } from '@spotify-internal/encore-web';
import { BannerState } from '../../@mrkt/features/Banner';
import { Track } from '../Tracking';
import { Layout, LayoutState } from '.';

export const Page: React.FC = (ctx: any) => {
  const { props, Component } = ctx;

  return (
    <Track>
      <BannerState>
        <LayoutState preview={props?.preview}>
          <Layout>
            <GlobalStyles noFonts />
            <Component {...props} />
          </Layout>
        </LayoutState>
      </BannerState>
    </Track>
  );
};
